import { GetChatbotTokenGateway } from '@remodeling/order';
import { axios } from '../../axios';

export const ChatbotGateway = () => {
  return {
    getChatbotToken: new GetChatbotTokenGateway(axios),
  };
};
